import { createContext, useContext } from 'react'

export const ChatContext = createContext()

export const useChatProviderContext = () => {
  const context = useContext(ChatContext)
  if (!context) throw new Error('ChatContext is null! Your component must be wrapped in a ChatProvider!')
  return context
}
